import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { scaleIncrementUp, scaleIncrementDown, setScale, setScaleMode } from "@builder/store/slices/frameTransformSlice";
import "./style.scss";
import { useEffect } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import TooltipElement from "@builder/components/general/Tooltip";

const ScaleInput = () => {
    const dispatch = useAppDispatch();
    const scale = useAppSelector(state => state.frameTransform.scale);
    const frameSize = useAppSelector(state => state.builder.frameSize);
    const sidebars = useAppSelector(state => state.sidebar);
    const zoomDisabled = useAppSelector(state => state.frameTransform.zoomDisabled);
    const { t } = useTranslation();

    useEffect(() => {
        if (scale.mode === "fill") {
            const frameWrapper = document.querySelector(".oliver-build-frame");
            if (frameWrapper) {
                const width = frameWrapper.clientWidth - frameWrapper.clientWidth * 0.0334;
                const height = frameWrapper.clientHeight - frameWrapper.clientHeight * 0.0481;
                const calculatedScale = width / frameSize.x;
                const finalScale = Math.floor(calculatedScale / 0.05) * 0.05;
                dispatch(setScale(finalScale));

                let frameHeight: number;
                if (frameSize.y === "fit-content") {
                    const oliverBuild = document.querySelector(".oliver-build");
                    frameHeight = oliverBuild ? oliverBuild.clientHeight : frameSize.x;
                } else {
                    frameHeight = frameSize.y;
                }

                const scaledHeight = frameHeight * finalScale;
                let translateY = 0;

                if (scaledHeight > height) {
                    const overflow = scaledHeight - height;
                    translateY = overflow / 2 / finalScale;
                }

                dispatch(setScaleMode({ mode: "fill", translateX: 0, translateY }));
            }
        } else if (scale.mode === "fit") {
            const frameWrapper = document.querySelector(".oliver-build-frame");
            if (frameWrapper) {
                const width = frameWrapper.clientWidth - frameWrapper.clientWidth * 0.0334;
                const height = frameWrapper.clientHeight - frameWrapper.clientHeight * 0.0481;
                const scaleX = width / frameSize.x;

                if (frameSize.y === "fit-content") {
                    const oliverBuild = document.querySelector(".oliver-build");
                    if (oliverBuild) {
                        const actualContentHeight = oliverBuild.clientHeight;
                        const scaleY = height / actualContentHeight;
                        dispatch(setScale(Math.floor(Math.min(scaleX, scaleY) / 0.05) * 0.05));
                    } else {
                        dispatch(setScale(Math.floor(scaleX / 0.05) * 0.05));
                    }
                } else {
                    const scaleY = height / frameSize.y;
                    dispatch(setScale(Math.floor(Math.min(scaleX, scaleY) / 0.05) * 0.05));
                }
                dispatch(setScaleMode({ mode: "fit", translateX: 0, translateY: 0 }));
            }
        }
    }, [scale.mode, frameSize.x, frameSize.y, sidebars, dispatch]);

    const handleMinusScale = () => {
        dispatch(scaleIncrementDown());
    };

    const handleAddScale = () => {
        dispatch(scaleIncrementUp());
    };

    const handleModeChange = () => {
        if (zoomDisabled) return;
        switch (scale.mode) {
            case "fill":
                dispatch(setScaleMode("fit"));
                break;
            case "fit":
                dispatch(setScaleMode("fill"));
                break;
            case "custom":
            default:
                dispatch(setScaleMode("fill"));
        }
    };

    const wrapperClass = classNames("scale-input-wrapper");

    return (
        <div className={wrapperClass}>
            <TooltipElement text="Zoom Out (Ctrl -)" translationPrefix="generalComponents.head.">
                <button onClick={handleMinusScale} disabled={scale.value <= 0.1 || zoomDisabled}>
                    <img src="/minus-icon.svg" alt="" />
                </button>
            </TooltipElement>
            <TooltipElement text={t(`scaleInput.fill / fit`)}>
                <input
                    type="text"
                    value={scale.mode === "custom" ? `${Math.round(scale.value * 100)}%` : t(`scaleInput.${scale.mode}`)}
                    readOnly
                    onClick={handleModeChange}
                    disabled={zoomDisabled}
                />
            </TooltipElement>
            <TooltipElement text="Zoom In (Ctrl +)" translationPrefix="generalComponents.head.">
                <button onClick={handleAddScale} disabled={scale.value >= 2 || zoomDisabled}>
                    <img src="/plus-icon.svg" alt="" />
                </button>
            </TooltipElement>
        </div>
    );
};

export default ScaleInput;
